import { captureAccessLinkFromLocation } from './lib/accessLink.js';

// Do this before importing or rendering any participant React code. The
// fragment is never sent to the server and is removed from browser history as
// soon as this JavaScript entry point runs.
if (!window.location.pathname.startsWith('/admin')) captureAccessLinkFromLocation();

// Keep React and the application graph behind this boundary so invitation and
// email-preference fragments are gone before any UI module initializes.
await import('./renderApplication.js');
